export default __webpack_public_path__ + "static/media/Karashika.e630b738.png";